import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Message = styled(Grid)({
  width: "100%",
  display: "flex",
  minHeight: "350px",
  alignItems: "center",
  flexFlow: "column",
  justifyContent: "center",
});
